import * as React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
    hideHome?: boolean
}

class ToTopComp extends React.Component<IProps, any> {
    public state = {
        visibleScrollToTop: false
    };
    public componentDidMount() {
        window.addEventListener('scroll', this.scrollAction);
    }
    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction);
    }
    public render() {
        return (
            <div className={`to-top ${this.state.visibleScrollToTop ? 'active' : ''}`}>
                <span onClick={() => this._toTopAction()}>
                    <img src={require('../../assets/images/icon-top.png')}/>
                </span>
                {
                    this.props.hideHome ? null :
                    <Link to="/">
                        <img src={require('../../assets/images/icon-home.png')}/>
                    </Link>
                }
            </div>
        )
    }
    // 跳转到底部
    private _toTopAction() {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }
    // 滚动显示隐藏
    private scrollAction = () => {
        if( window.pageYOffset > 200 ) {
            if(!this.state.visibleScrollToTop) {
              this.setState({visibleScrollToTop: true});
            }
        } else {
            if(this.state.visibleScrollToTop) {
                this.setState({visibleScrollToTop: false});
            }
        }
    }
}

export default ToTopComp;


// WEBPACK FOOTER //
// ./src/components/common/toTop.tsx